import { Classes } from '@blueprintjs/core';
import * as React from 'react';

import { copy } from 'src/ui/templates/copy';
import auth0Icon from 'src/ui/templates/images/auth0-icon.svg';
import { doAuth0Redirect } from 'src/ui/utils/window';

/**
 * This uses just a plain button as we use an image to display the actual
 * button. We don't want this to be styled by blueprintjs.
 */
export const Auth0Link: React.VFC = () => {
  return (
    <button
      type="button"
      onClick={() => doAuth0Redirect()}
      className={`${Classes.BUTTON} oauth`}
    >
      <img src={auth0Icon} alt={copy.auth0.label} />
      {copy.auth0.label}
    </button>
  );
};
